"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var GroupsController_1 = require("./GroupsController");
var ExperimentsController_1 = require("./ExperimentsController");
// DO NOT change. Long imports are intentional here
var BaseWidgetController_1 = require("@wix/social-groups-common/dist/src/BaseWidgetController");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var WidgetController = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetController, _super);
    function WidgetController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.handleGroupCardCTA = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupId, relationship;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupId = group.groupId, relationship = group.relationship;
                        if (relationship === social_groups_api_1.ApiTypes.v1.RelationshipWithGroup.JOINED) {
                            this.groupsController.goToGroup(groupId);
                            return [2 /*return*/];
                        }
                        if (!!this.isUserLoggedIn()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.promptLogin()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.groupsController.changeMembership(group)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.updateGroups()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.groupsController = new GroupsController_1.default(controllerConfig);
        var appParams = controllerConfig.appParams, setProps = controllerConfig.setProps, wixCodeApi = controllerConfig.wixCodeApi, config = controllerConfig.config;
        _this.wixCodeApi = wixCodeApi;
        _this.appParams = appParams;
        _this.setProps = setProps;
        _this.config = config;
        _this.baseUrl = baseUrl_1.default(wixCodeApi);
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.groupsController.refreshApiToken(instance);
                            this.setProps({
                                isUserLoggedIn: this.isUserLoggedIn(),
                            });
                            return [4 /*yield*/, this.updateGroups()];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        });
        return _this;
    }
    WidgetController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, groups, experiments;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.groupsController.fetchGroups(),
                            ExperimentsController_1.default.getExperiments(),
                        ])];
                    case 1:
                        _a = _b.sent(), groups = _a[0], experiments = _a[1];
                        this.setInitialProps(groups, experiments);
                        return [2 /*return*/];
                }
            });
        });
    };
    WidgetController.prototype.updateConfig = function ($w, updatedConfig) {
        this.config = updatedConfig;
        this.setProps({
            styleParams: updatedConfig.style.styleParams,
        });
    };
    Object.defineProperty(WidgetController.prototype, "exports", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    WidgetController.prototype.setInitialProps = function (groups, experiments) {
        this.setProps({
            groups: groups,
            actions: {
                createGroup: this.groupsController.createGroup,
                goToGroup: this.groupsController.goToGroup,
                promptLogin: this.promptLogin,
                handleGroupCardCTA: this.handleGroupCardCTA,
            },
            cssBaseUrl: this.appParams.baseUrls.staticsBaseUrl,
            isUserLoggedIn: this.isUserLoggedIn(),
            experiments: experiments,
            locale: this.getLocale(),
            styleParams: this.config.style.styleParams,
        });
    };
    WidgetController.prototype.updateGroups = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.groupsController.fetchGroups()];
                    case 1:
                        groups = _a.sent();
                        this.setProps({ groups: groups });
                        return [2 /*return*/];
                }
            });
        });
    };
    return WidgetController;
}(BaseWidgetController_1.BaseWidgetController));
function createGroupsAppController(controllerConfig) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new WidgetController(controllerConfig)];
        });
    });
}
exports.createGroupsAppController = createGroupsAppController;
//# sourceMappingURL=appController.js.map